import { useState  } from 'react'
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import MissionPage from './pages/MissionPage'
import GlancePage from './pages/GlancePage'
import Achievements from './pages/Achievements'
import NoticeDetails from "./pages/NoticeDetails";
import AllNotice from "./pages/AllNotice";
import NewsDetails from "./pages/NewsDetails";
import NewsList from "./pages/NewsList";
import VcMessage from "./pages/VcMessage";
import ProVcMessage from "./pages/ProVcMessage";
import TreasurerMessage from "./pages/TreasurerMessage";
import RegistrarMessage from "./pages/RegistrarMessage";
import VideoPage from "./pages/VideoPage";
import FaqPage from "./pages/FaqPage";
import ContactPage from "./pages/ContactPage";
import CareerPage from "./pages/CareerPage";
import CareerDetails from "./pages/CareerDetails";
import FacultyPage from "./pages/FacultyPage";
import ProfilePage from "./pages/ProfilePage";
import CsePage from "./pages/program/CsePage";
import BbaPage from "./pages/program/BbaPage";
import GdsPage from "./pages/program/GdsPage";
import EngPage from "./pages/program/EngPage";
import HtmPage from "./pages/program/HtmPage";
import MbaPage from "./pages/program/MbaPage";
import Acfd from "./pages/Acfd";
import Coe from "./pages/Coe";
import Pro from "./pages/Pro";
import AdmDiv from "./pages/AdmDiv";
import Librarian from "./pages/Librarian";
import AcPage from "./pages/AcPage";
import Syndicate from "./pages/Syndicate";
import Deans from "./pages/Deans";
import Proctor from "./pages/Proctor";
import Itd from "./pages/Itd";
import Iqac from "./pages/Iqac";
import Transport from "./pages/Transport";
import AuditCell from "./pages/AuditCell";
import SecOff from "./pages/SecOff";
import AdmReq from "./pages/AdmReq";
import AdmTest from "./pages/AdmTest";
import AdmIns from "./pages/AdmIns";
import AdmAdv from "./pages/AdmAdv";
import FinAid from "./pages/FinAid";
import FeesPage from "./pages/FeesPage";
import AdmForm from "./pages/AdmForm";
import AdmitCard from "./pages/AdmitCard";
import OfferLetter from "./pages/OfferLetter";
import AdmResult from "./pages/AdmResult";
import DCse from "./pages/CsePage";
import DbaPage from "./pages/DbaPage";
import DEng from "./pages/EngPage";
import DGds from "./pages/GdsPage";
import DHtm from "./pages/HtmPage";
import LawPage from "./pages/LawPage";
import AcCalendar from "./pages/AcCalendar";
import CertificateVerification from "./pages/CertificateVerification";
import InternationalAffairs from "./pages/InternationalAffairs";
import RegMessage from "./pages/RegMessage";
import ApplyOnline from './pages/ApplyOnline';
import BoTMessage from './pages/BoTMessage';
import CERTI from "./pages/CERTI";
import GDSDepartment from "./pages/department/GDSDepartment";
import EngDepartment from "./pages/department/EngDepartment";
import CSEDepartment from "./pages/department/CSEDepartment";
import DBADepartment from "./pages/department/DBADepartment";
import HTMDepartment from "./pages/department/HTMDepartment";

function App() { 
	
	return (		
    <Router>
	  <Routes>
		<Route path="/" element={<MainLayout />}>
			<Route index element={<HomePage />} />
			<Route path="about" element={<AboutPage />} />
			<Route path="mission-vision" element={<MissionPage />} />
			<Route path="at-a-glance" element={<GlancePage />} />
			<Route path="achievements" element={<Achievements />} />
			<Route path="/notice/:id" element={<NoticeDetails />} />
			<Route path="all-notice" element={<AllNotice />} />
			<Route path="/news/:id" element={<NewsDetails />} />
			<Route path="all-news" element={<NewsList />} />
			<Route path="vc" element={<VcMessage />} />
			<Route path="provc" element={<ProVcMessage />} />
			<Route path="treasurer" element={<TreasurerMessage />} />
			<Route path="registrar" element={<RegistrarMessage />} />
			<Route path="videos" element={<VideoPage />} />
			<Route path="faq" element={<FaqPage />} />
			<Route path="contact" element={<ContactPage />} />
			<Route path="career" element={<CareerPage />} />
			<Route path="/career-details/:id" element={<CareerDetails />} />
			<Route path="/faculty" element={<FacultyPage />} />
			<Route path="/profile/:id" element={<ProfilePage />} />
			{/* Add more routes for other pages */}
			<Route path="program">
				<Route path="cse" element={<CsePage />} />
				<Route path="bba" element={<BbaPage />} />
				<Route path="gds" element={<GdsPage />} />
				<Route path="english" element={<EngPage />} />
				<Route path="htm" element={<HtmPage />} />
				<Route path="Mba" element={<MbaPage />} />
			</Route>
			<Route path="/acfd" element={<Acfd />} />
			<Route path="/coe" element={<Coe />} />
			<Route path="/pro" element={<Pro />} />
			<Route path="/admission-division" element={<AdmDiv />} />
			<Route path="/librarian" element={<Librarian />} />
			<Route path="/academic-council" element={<AcPage />} />
			<Route path="/syndicate" element={<Syndicate />} />
			<Route path="/deans" element={<Deans />} />
			<Route path="/proctor" element={<Proctor />} />
			<Route path="/itd" element={<Itd />} />
			<Route path="/iqac" element={<Iqac />} />
			<Route path="/transport-office" element={<Transport />} />
			<Route path="/audit-cell" element={<AuditCell />} />
			<Route path="/security-office" element={<SecOff />} />
			<Route path="/admission-requirements" element={<AdmReq />} />
			<Route path="/admission-test" element={<AdmTest />} />
			<Route path="/admission-instruction" element={<AdmIns />} />
			<Route path="/admission-advertisements" element={<AdmAdv />} />
			<Route path="/financial-aid" element={<FinAid />} />
			<Route path="/fees" element={<FeesPage />} />
			<Route path="/admission-form" element={<AdmForm />} />
			<Route path="/admit-card" element={<AdmitCard />} />
			<Route path="/offer-letter" element={<OfferLetter />} />
			<Route path="/admission-result" element={<AdmResult />} />
			<Route path="/cse" element={<DCse />} />
			<Route path="/dba" element={<DbaPage />} />
			<Route path="/eng" element={<DEng />} />
			<Route path="/gds" element={<DGds />} />
			<Route path="/htm" element={<DHtm />} />
			<Route path="/law" element={<LawPage />} />
			<Route path="/academic-calendar" element={<AcCalendar />} />
			<Route path="/certificate-verification" element={<CertificateVerification />} />
			<Route path="/international-affairs" element={<InternationalAffairs />} />
			<Route path="/registrar-message" element={<RegMessage />} />
			<Route path="/apply-online" element={<ApplyOnline />} />
			<Route path="/bot-meessage" element={<BoTMessage />} />
			<Route path="/certi" element={<CERTI  />} />
			<Route path="department">				
				<Route path="gds" element={<GDSDepartment />} />	
				<Route path="eng" element={<EngDepartment />} />
				<Route path="cse" element={<CSEDepartment />} />
				<Route path="dba" element={<DBADepartment />} />
				<Route path="htm" element={<HTMDepartment />} />
			</Route>
		</Route>
	  </Routes>
	</Router>
	)
}

export default App
